import { render, staticRenderFns } from "./Delete.vue?vue&type=template&id=66f9aeb9&scoped=true&"
import script from "./Delete.vue?vue&type=script&lang=js&"
export * from "./Delete.vue?vue&type=script&lang=js&"
import style0 from "./Delete.vue?vue&type=style&index=0&id=66f9aeb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f9aeb9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66f9aeb9')) {
      api.createRecord('66f9aeb9', component.options)
    } else {
      api.reload('66f9aeb9', component.options)
    }
    module.hot.accept("./Delete.vue?vue&type=template&id=66f9aeb9&scoped=true&", function () {
      api.rerender('66f9aeb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/Delete.vue"
export default component.exports